export const SETTINGS_ROUTES = {
    Settings: 'settings',
    MailboxesSettings: 'MailboxesSettings',
    AddMailboxesSettings: 'AddMailboxesSettings',
    UsersSettings: 'UsersSettings',
    TeamsSettings: 'TeamsSettings',
    BusinessSettings: 'BusinessSettings',
    MetricAdjustments: 'MetricAdjustments',
    ContactGroupsSettings: 'ContactGroupsSettings'
};
